import { Link } from 'react-router-dom';
import { footerContent } from '@/mocks/seoContent';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-16">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-20">
          <div className="lg:w-1/4">
            <Link to="/" className="inline-block mb-4 no-underline">
              <span className="text-xl font-heading tracking-tight text-foreground-950 whitespace-nowrap">
                Kakobuy<span className="text-primary-500">Finds</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {footerContent.description}
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            {footerContent.navColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400 mb-4 whitespace-nowrap">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.links.map((link, i) => {
                    const isExternal = link.href.startsWith('http');
                    const isHashLink = link.href.startsWith('#');
                    if (isExternal) {
                      return (
                        <li key={i}>
                          <a
                            href={link.href}
                            target="_blank"
                            rel="noopener nofollow"
                            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                          >
                            {link.label}
                          </a>
                        </li>
                      );
                    }
                    if (isHashLink) {
                      return (
                        <li key={i}>
                          <span className="text-sm text-foreground-300 whitespace-nowrap cursor-not-allowed">
                            {link.label}
                            <span className="text-xs text-foreground-300 ml-1">(coming soon)</span>
                          </span>
                        </li>
                      );
                    }
                    return (
                      <li key={i}>
                        <Link
                          to={link.href}
                          className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                        >
                          {link.label}
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Kakobuy Finds. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              Kakobuy Sheet
            </a>
            <span className="text-foreground-300">|</span>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-400 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}